import type { Socket } from 'socket.io-client';
import { create } from 'zustand';

interface SocketState {
  socket?: Socket;
  setSocket: (socket: Socket) => void;
}

export const useSocketStore = create<SocketState>()((set) => ({
  socket: undefined,
  setSocket: (socket) => set(() => ({ socket })),
}));
